import { BrowserService } from '../../../../lib/services/browser'
import { compareVersions } from '../../../../lib/utils/compare'

const macOsVersionParser = (v: string): number[] => {
  return v
    .trim()
    .split(/[._]/)
    .map((v) => Number(v))
}

const isEligibleMacVersion = (osVersion?: string): boolean => {
  const targetVersion = '10.15'
  if (!osVersion) {
    return true // If we cannot parse version then allow by default
  }

  return compareVersions(osVersion, targetVersion, macOsVersionParser) >= 0
}

const isEligibleWindowsVersion = (windowsOsVersion?: string): boolean => {
  if (!windowsOsVersion) {
    return true // If windows os version information is not available, return true by default
  }

  const ineligibleWindowsVersions = ['7', '8', '8.1']

  return !ineligibleWindowsVersions.includes(windowsOsVersion)
}

export const isEligibleForLlamaForMac = (browserService: BrowserService): boolean => {
  const { isMac, isIPad, macOsVersion } = browserService

  return isMac && !isIPad && isEligibleMacVersion(macOsVersion)
}

export const isEligibleForLlamaForWindows = (browserService: BrowserService): boolean => {
  const { isWindows, windowsOsVersion } = browserService

  return isWindows && isEligibleWindowsVersion(windowsOsVersion)
}
